export var TimeFormatsConstants = {
    TWELVE_HOUR: 'h:mm a',
    TWELVE_HOUR_NO_MERIDIAN: 'h:mm',
    TWENTY_FOUR_HOUR: 'HH:mm',
};
/* @TODO Update this to be lowercase */
export var ComposerMode = {
    CREATE: 'create',
    EDIT: 'edit',
};
/**
 * Abstract buffer event types used by the shared EventComposer component.
 * These are mapped to app-specific Amplitude event names at the application level.
 */
export var BufferEventType = {
    ADDED_BUFFER: 'addBuffer',
    REMOVED_BUFFER: 'removeBuffer',
    CREATED_BUFFER_EVENT: 'createdBufferEvent',
    DETECTED_BUFFER_CONFLICT: 'detectedBufferConflict',
};
